// extracted by mini-css-extract-plugin
export var bigText = "all-on-4-module--big-text--52578";
export var image = "all-on-4-module--image--c6e33";
export var item = "all-on-4-module--item--45be7";
export var itemTitle = "all-on-4-module--item-title--76d8c";
export var richText = "all-on-4-module--rich-text--c2fd7";
export var slide = "all-on-4-module--slide--98082";
export var text = "all-on-4-module--text--8b0f5";